<template>
  <div class="attendance-report">
    <div v-if="loading || loadingResult" class="text-center loading">
      <b-spinner small></b-spinner>
    </div>

    <div v-else-if="resultData && resultData.length > 0" class="table-container">
      <table class="attendance-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in resultData" :key="index" :class="{ 'even-row': index % 2 === 0 }">
            <td><b>{{ item.title }}</b></td>
            <td class="text-capitalize" v-if="item.resultStatus === 'pending'">Pending</td>
            <td class="text-capitalize" v-else>
              {{ item.result }} marks ({{ item.percentage }}%)
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="text-center text-muted">
      No exam data available.
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ContentType } from "../../../constants/content";

export default {
  name: "ExamResult",
  props: {
    studentId: { type: String, required: true },
    productVariantId: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      loadingResult: false,
      contents: [],
      examResults: {}, // keyed by content.id
      resultData: [],
    };
  },
  methods: {
    ...mapActions("content", ["fetchContentListByProductVariant"]),
    ...mapActions("exam", ["getExamResultByProductVariant"]),

    async fetchContentList() {
      try {
        this.loading = true;
        const res = await this.fetchContentListByProductVariant({
          id: this.productVariantId,
          contentType: ContentType.EXAM,
        });
        this.contents = res || [];
        this.buildResultData();
      } catch (error) {
        console.error("Error fetching exam content:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchExamResults() {
      try {
        this.loadingResult = true;
        const results = await this.getExamResultByProductVariant({
          productVariantID: this.productVariantId,
          studentID: this.studentId,
        });

        if (results) {
          results.forEach((res) => {
            this.examResults[res.content.id] = res;
          });
        }

        this.buildResultData();
      } catch (error) {
        console.error("Error fetching exam results:", error);
      } finally {
        this.loadingResult = false;
      }
    },

    buildResultData() {
      this.resultData = this.contents
        .map((content) => {
          const result = this.examResults[content.id];
          return {
            title: content.title,
            passing_percentage: result ? result.passingPercentage : "-",
            resultStatus: result ? "graded" : "pending",
            percentage: result ? result.percentage : 0,
            result: result ? result.result : 0,
            sequence: content.sequence || 9999,
          };
        })
        .sort((a, b) => a.sequence - b.sequence);
    },
  },

  async created() {
    await this.fetchContentList();
    await this.fetchExamResults();
  },
};
</script>

<style scoped>
.attendance-report {
  padding: 1rem 0;
  padding-top: 0;
}

.table-container {
    overflow-x: auto;
    border-radius: 0 !important;
    max-height: 80vh;
  }


.attendance-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.attendance-table tr:hover {
  background: #f2f2f2 !important;
}

.attendance-table th,
.attendance-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.attendance-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  position: sticky;
  top: 0;
  z-index: 1;
}

.attendance-table tr.even-row {
  background: #f9f9f9;
}

.attendance-table tr:hover {
  background: #e0f7fa;
  transition: background 0.3s ease;
}

.attendance-table td {
  color: #34495e;
  font-size: 1rem;
}

.text-muted {
  color: #7f8c8d;
}

.content-type-icon {
  height: 2rem;
}

.text-capitaliaze {
  text-transform: capitalize;
}

.loading {
  display: flex;
  justify-content: center;
  margin: 2rem;
  color: var(--primary-color);
}

@media (max-width: 767px) {
  .table-container {
    max-width: 600px;
  }

  .attendance-table th,
  .attendance-table td {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
}
</style>